import React, { useRef, useState } from 'react';
import styles from './file-upload.module.scss';

const FileUpload = ({ onFileSelect, accept = '.pdf', multiple = true, maxSizeMB = 25 }) => {
    const fileInputRef = useRef(null);
    const [files, setFiles] = useState([]);
    const [dragActive, setDragActive] = useState(false);
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    const handleFileChange = (e) => {
        const newFiles = Array.from(e.target.files || e.dataTransfer.files);

        const validFiles = newFiles.filter((file) => {
            if (file.size > maxSizeBytes) {
                alert(`"${file.name}" is too large. Max size is ${maxSizeMB}MB.`);
                return false;
            }
            return true;
        });

        const updatedFiles = multiple ? [...files, ...validFiles] : validFiles.slice(0, 1);
        setFiles(updatedFiles);
        onFileSelect(multiple ? updatedFiles : updatedFiles[0]);
    };

    const handleRemove = (index) => {
        const updatedFiles = [...files];
        updatedFiles.splice(index, 1);
        setFiles(updatedFiles);
        onFileSelect(multiple ? updatedFiles : null);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragActive(false);
        handleFileChange(e);
    };

    return (
        <div
            className={`${styles.uploadContainer} ${dragActive ? styles.active : ''}`}
            onDragOver={(e) => {
                e.preventDefault();
                setDragActive(true);
            }}
            onDragLeave={() => setDragActive(false)}
            onDrop={handleDrop}
            onClick={() => fileInputRef.current.click()}
        >
            <input
                type='file'
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
                accept={accept}
                multiple={multiple}
            />
            <p>Drag & drop files here or click to upload</p>

            {files.length > 0 && (
                <ul className={styles.fileList}>
                    {files.map((file, index) => (
                        <li key={index} className={styles.fileItem}>
                            <span>
                                {file.name} ({(file.size / (1024 * 1024)).toFixed(2)} MB)
                            </span>
                            <button
                                type='button'
                                className={styles.removeButton}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleRemove(index);
                                }}
                            >
                                ✕
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default FileUpload;
